import { enumify, Enumify } from '@mews/enumify';

function BaseHttpStatusCodeGroup() {}

const config = {
    Success: { from: 200, to: 299 },
    Redirection: { from: 300, to: 399 },
    ClientErrors: { from: 400, to: 499 },
    ServerErrors: { from: 500, to: 599 },
};
type Keys = keyof typeof config;
type Values = (typeof config)[Keys];
enumify<Keys, Values>(BaseHttpStatusCodeGroup, 'HttpStatusCodeGroup', config);

export const HttpStatusCodeGroup = BaseHttpStatusCodeGroup as unknown as Enumify<Keys, Values>;
